// extracted by mini-css-extract-plugin
module.exports = {"c-SettingPage-NewPreferencesPage":"NewPreferences_c-SettingPage-NewPreferencesPage__1n1uS"};